import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'ref-footer',
    templateUrl: './ref-footer.component.html',
    styleUrls: ['./ref-footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
